import Button from "antd/lib/button";
import Col from "antd/lib/col";
import Row from "antd/lib/row";
import Space from "antd/lib/space";
import Typography from "antd/lib/typography";

import { ButtonProps } from "antd/lib/button";
import { MAXIMUM_MISTAKES, State } from "../../models/gameModels.ts";
import { useAuth } from "../../services/firebase.ts";
import { sizes } from "../../styles/sizes.ts";
import { colors } from "../../styles/themes.tsx";
import { GameConfig, GameEvents } from "./Game.tsx";
import { GameMethods } from "./gameMethods.ts";

const ControlButton = ({ children, ...props }: ButtonProps) => {
  return (
    <Button
      type="default"
      size="large"
      style={{
        borderWidth: "1px",
        fontFamily: "arial",
        fontWeight: "600",
        lineHeight: "1.1em",
        margin: "4px",
        WebkitFontSmoothing: "antialiased",
        outlineStyle: "solid",
        outlineWidth: "2px",
        outlineOffset: "2px",
        outlineColor: "rgba(0,0,0,0)",
        borderRadius: "9999px",
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

const MistakesTypography = ({
  mistakesRemaining,
}: {
  mistakesRemaining: number;
}) => {
  return (
    <Space
      tabIndex={0}
      role={"button"}
      align="baseline"
      aria-label={`טעויות שנותרו
      : ${mistakesRemaining} מתוך ${MAXIMUM_MISTAKES}`}
      aria-live={"polite"}
    >
      <Typography.Text aria-hidden={true}>טעויות שנותרו:</Typography.Text>
      {Array.from({ length: mistakesRemaining }, (_, i) => (
        <div
          aria-hidden={true}
          key={i}
          data-testid={"mistakes remaining"}
          style={{
            width: 12,
            height: 12,
            borderRadius: "50%",
            backgroundColor: colors.mistakeCircle,
          }}
        ></div>
      ))}
    </Space>
  );
};

const GameControls = ({
  fns,
  state,
  triggers,
  config,
}: {
  state: State;
  fns: GameMethods;
  triggers: GameEvents;
  config: GameConfig;
}) => {
  const user = useAuth();
  const gameOver =
    state?.incomplete?.length === 0 || state?.mistakesRemaining === 0;

  return (
    <Row align="middle" style={{ width: sizes.viewWidth, padding: "10px" }}>
      <Col span={24} style={{ paddingBottom: "8px" }}>
        <MistakesTypography mistakesRemaining={state.mistakesRemaining} />
      </Col>
      {!gameOver ? (
        <>
          <ControlButton
            onClick={fns.shuffle}
            disabled={state.animationInProgress != "NONE"}
          >
            ערבל
          </ControlButton>
          <ControlButton
            onClick={fns.deselectAll}
            disabled={state.animationInProgress != "NONE"}
          >
            הסר בחירה
          </ControlButton>
          <ControlButton
            disabled={
              state.activeItems.length !== 4 ||
              state.animationInProgress != "NONE"
            }
            onClick={fns.submit}
            aria-disabled={state.activeItems.length !== 4}
          >
            שלח
          </ControlButton>
        </>
      ) : (
        <>
          <ControlButton
            onClick={() => triggers.onShowModal?.(state)}
            disabled={
              !["NONE", "GAME-FINISHED-WIN", "GAME-FINISHED-LOSE"].includes(
                state.animationInProgress,
              )
            }
          >
            לסיכום
          </ControlButton>
        </>
      )}
      {config.showAdmin && (
        <>
          <ControlButton onClick={() => fns.clear(user)}>נקה</ControlButton>
        </>
      )}
    </Row>
  );
};

export default GameControls;
